import axiosInstance from '@/lib/axios';
import { UpdateBasicInfoPayload, AiRoleResponse, UpdateBasicInfoResponse, UpdateConfigPayload, UpdateConfigResponse, UpdateAppearancePayload, UpdateAppearanceResponse, DataFieldCreatePayload, CreateDataFieldResponse, GetDataFieldsResponse, DataFieldUpdatePayload, UpdateDataFieldResponse, DeleteDataFieldResponse, UploadLogoResponse, DataColletionPayload, DataColletionResponse } from '../types/types';
import { ChatbotBuilderResponse, WhatsAppConnectionResponse } from '../types/chatbotbuilder.type';



export const chatbotsService = {

  getChatbotBuilder: async (chatbotId: string, visitorId: string): Promise<ChatbotBuilderResponse> => {
    try {
      const response = await axiosInstance.get<ChatbotBuilderResponse>(
        `/chatbot-builder/${chatbotId}?visitorId=${visitorId}`
      );
      return response.data;
    } catch (error: any) {
      console.error('Error fetching chatbot builder data:', error);
      throw error;
    }
  },

  disconnectWhatsApp: async (chatBotId: string): Promise<void> => {
    await axiosInstance.delete(`/chatbot-builder/${chatBotId}/whatsapp/disconnect`);
  },

  refreshFacebookStatus: async (chatBotId: string): Promise<WhatsAppConnectionResponse> => {
    try {
      const response = await axiosInstance.post<WhatsAppConnectionResponse>(
        `/chatbot-builder/${chatBotId}/whatsapp/facebook-status/refresh`
      );
      return response.data;
    } catch (error: any) {
      console.error('Error refreshing Facebook status:', error);
      throw error;
    }
  },


  getAiRole: async (): Promise<AiRoleResponse> => {
    try {
      const response = await axiosInstance.get<AiRoleResponse>(
        `/chatbot-builder/persona-list`
      );
      return response.data;
    } catch (error: any) {
      console.error('Error fetching chatbot builder data:', error);
      throw error;
    }
  },

  updateBasicInfo: async (chatbotId: string, data: UpdateBasicInfoPayload): Promise<UpdateBasicInfoResponse> => {
    const response = await axiosInstance.put<UpdateBasicInfoResponse>(
      `/chatbot-builder/${chatbotId}/basic`,
      data
    );
    return response.data;
  },

  submitDataColletion: async (chatbotId: string, data: DataColletionPayload): Promise<DataColletionResponse> => {
    const response = await axiosInstance.post<DataColletionResponse>(
      `/widget/chatbot/${chatbotId}/data-collection/submit`,
      data, {
      withCredentials: false,
    }
    );
    return response.data;
  },

  updateConfig: async (chatbotId: string, data: UpdateConfigPayload): Promise<UpdateConfigResponse> => {
    const response = await axiosInstance.put<UpdateConfigResponse>(
      `/chatbot-builder/${chatbotId}/config`,
      data
    );
    return response.data;
  },

  updateAppearance: async (chatbotId: string, data: UpdateAppearancePayload): Promise<UpdateAppearanceResponse> => {
    const response = await axiosInstance.put<UpdateAppearanceResponse>(
      `/chatbot-builder/${chatbotId}/appearance`,
      data
    );
    return response.data;
  },

  createDataField: async (chatbotId: string, data: DataFieldCreatePayload): Promise<CreateDataFieldResponse> => {
    const response = await axiosInstance.post<CreateDataFieldResponse>(
      `/chatbot-builder/${chatbotId}/data-collection`,
      data
    );
    return response.data;
  },

  getDataFields: async (chatbotId: string): Promise<GetDataFieldsResponse> => {
    try {
      const response = await axiosInstance.get<GetDataFieldsResponse>(
        `/chatbot-builder/${chatbotId}/data-collection`
      );
      return response.data;
    } catch (error) {
      throw error
    }
  },

  updateDataField: async (chatbotId: string, fieldId: string, data: DataFieldUpdatePayload): Promise<UpdateDataFieldResponse> => {
    const response = await axiosInstance.put<UpdateDataFieldResponse>(
      `/chatbot-builder/${chatbotId}/data-collection/${fieldId}`,
      data
    );
    return response.data;
  },

  deleteDataField: async (chatbotId: string, fieldId: string): Promise<DeleteDataFieldResponse> => {
    const response = await axiosInstance.delete<DeleteDataFieldResponse>(
      `/chatbot-builder/${chatbotId}/data-collection/${fieldId}`
    );
    return response.data;
  },

  uploadLogo: async (chatbotId: string, file: File): Promise<UploadLogoResponse> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axiosInstance.post<UploadLogoResponse>(
      `${import.meta.env.VITE_API_URL}/chatbot-builder/${chatbotId}/upload-logo`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },
};